module.exports = __webpack_public_path__ + "img/1.708a98d7.jpg";